module.exports = __webpack_public_path__ + "static/media/WBD-FINAL_page-0007.4c6278d2.jpg";